module.exports = __webpack_public_path__ + "media/stylesheets/images/media/attracting_image1-fae98edf5257545e9c286050ebf944de.jpg";